import interestQuerySoundUrl from '../assets/audio/interest-query.mp3'
import notificationSoundUrl from '../assets/audio/notification.mp3'
import callWaitSoundUrl from '../assets/audio/ziptone.mp3'

export const playFx = (type) => {
  const soundMap = {
    notification: notificationSoundUrl,
    interest: interestQuerySoundUrl,
    call_wait: callWaitSoundUrl,
  }

  const audioSrc = soundMap[type]
  if (!audioSrc) {
    console.warn(`Unknown sound type: ${type}`)
    return
  }

  const audio = new Audio(audioSrc)
  audio.play().catch((e) => {
    console.warn(`Sound playback failed for type "${type}":`, e)
  })
}
